// //Components/OrderForm/OrderForm.jsx
// // "use client";
// import React, { useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// // CSS
// import "./order-form.css";
// import { useCart } from "../../context/CartContext";

// const OrderForm = () => {
//   const { cart, setCart } = useCart();

//   const [form, setForm] = useState({
//     name: "",
//     address: "",
//     phoneNumber: "",
//     email: "",
//     instructions: "",
//   });

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   // const [success, setSuccess] = useState(null);
//   const navigate = useNavigate();

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError(null);
//     // setSuccess(null);

//     const requestData = {
//       name: form.name,
//       address: form.address,
//       phone: form.phoneNumber, // Keep `phoneNumber`, backend expects `phone`
//       email: form.email,
//       request: form.instructions, // Keep `instructions`, backend expects `request`
//       cart: cart.map((item) => ({
//         id: item._id,
//         // category: item.category,
//         // name: item.title,
//         // price: item.price,
//         quantity: item.quantity,
//         // description: item.description,
//       })),
//     };

//     try {
//       const response = await axios.post(
//         // "https://ekhoni-khabo-server.vercel.app/api/v1/customer/send-message",
//         "https://ekhoni-khabo-server.vercel.app/api/v1/customer/send-message",
//         requestData,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         },
//       );

//       console.log("Order submitted successfully:", response.data);
//       // setSuccess("Order placed successfully!");
//       setForm({
//         name: "",
//         address: "",
//         phoneNumber: "",
//         email: "",
//         instructions: "",
//       });
//       if (response.status === 200) {
//         setCart([]);
//         localStorage.removeItem("cart");
//         localStorage.removeItem("cartTimestamp");
//         navigate("/", {
//           state: {
//             success: "Order placed successfully! We will call you to confirm!",
//           },
//         });
//       } else {
//         toast("Failed to place order. Please try again.");
//       }
//     } catch (err) {
//       console.error("Error submitting order:", err);
//       setError("Failed to place order. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };
//   if (cart.length === 0) {
//     return (
//       <section className="order-form-empty">
//         <div className="order-form-container">
//           <h3 className="order-form-heading">Your cart is empty</h3>
//           <p className="order-form-description">
//             Please add items to your cart before placing an order.
//           </p>
//         </div>
//       </section>
//     );
//   }

//   return (
//     <section className="order-form" id="order-form">
//       <div className="order-form-container">
//         <h3 className="order-form-heading">Order Delivery Details</h3>
//         <p className="order-form-description">
//           Please fill up this form to confirm your order and delivery
//         </p>
//         <p className="text-xl font-bold text-center pb-3">
//           Once you have placed your order, our customer service will call you
//           and confirm your order
//         </p>
//         <p className="text-xl font-bold text-center pb-3">
//           {
//             "(আপনি আপনার অর্ডার দেওয়ার পরে, আমাদের গ্রাহক পরিষেবা আপনাকে কল করবে এবং আপনার অর্ডার নিশ্চিত করবে)"
//           }
//         </p>
//         {error && <p className="error-message">{error}</p>}
//         {/* {success && <p className="success-message">{success}</p>} */}
//         <ToastContainer
//           position="top-right"
//           autoClose={5000}
//           hideProgressBar={false}
//           newestOnTop={false}
//           closeOnClick={false}
//           rtl={false}
//           pauseOnFocusLoss
//           draggable
//           pauseOnHover
//           theme="dark"
//         />
//         <form className="form" onSubmit={handleSubmit}>
//           <div className="form-group name-group">
//             <label htmlFor="name" className="form-label">
//               Name*
//             </label>
//             <input
//               type="text"
//               id="name"
//               name="name"
//               value={form.name}
//               onChange={handleChange}
//               placeholder="Your name"
//               className="form-input"
//               required
//             />
//           </div>

//           <div className="form-group address-group">
//             <label htmlFor="address" className="form-label">
//               Address*
//             </label>
//             <input
//               type="text"
//               id="address"
//               name="address"
//               value={form.address}
//               onChange={handleChange}
//               placeholder="Your address"
//               className="form-input"
//               required
//             />
//           </div>

//           <div className="form-group phone-number-group">
//             <label htmlFor="phoneNumber" className="form-label">
//               Phone Number*
//             </label>
//             <input
//               type="text"
//               id="phoneNumber"
//               name="phoneNumber"
//               value={form.phoneNumber}
//               onChange={handleChange}
//               placeholder="Your phone no"
//               className="form-input"
//               required
//             />
//           </div>

//           <div className="form-group email-group">
//             <label htmlFor="email" className="form-label">
//               Email
//             </label>
//             <input
//               type="string"
//               id="email"
//               name="email"
//               value={form.email}
//               onChange={handleChange}
//               placeholder="Your email"
//               className="form-input"
//             />
//           </div>

//           <div className="form-group instructions-group">
//             <label htmlFor="instructions" className="form-label">
//               Requests / Message
//             </label>
//             <textarea
//               id="instructions"
//               name="instructions"
//               value={form.instructions}
//               onChange={handleChange}
//               placeholder="Any special request / message you might have on the order or the delivery"
//               className="form-textarea"
//             ></textarea>
//           </div>

//           <button type="submit" className="form-btn btn btn-primary">
//             {loading ? "Submitting..." : "Order"}
//           </button>
//         </form>
//       </div>
//     </section>
//   );
// };

// export default OrderForm;

// components/OrderForm/OrderForm.jsx
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
// CSS
import "./order-form.css";
import { useCart } from "../../context/CartContext";

const OrderForm = () => {
  const { cart, setCart } = useCart();

  const [form, setForm] = useState({
    name: "",
    address: "",
    phoneNumber: "",
    email: "",
    instructions: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const totalAmount = cart.reduce(
      (sum, item) => sum + item.price * item.quantity,
      0,
    );
    const deliveryCharge = 50;
    const grandTotal = totalAmount + deliveryCharge;

    const requestData = {
      name: form.name,
      address: form.address,
      phone: form.phoneNumber,
      email: form.email,
      request: form.instructions,
      cart: cart.map((item) => ({
        id: item._id,
        quantity: item.quantity,
      })),
    };

    try {
      const response = await axios.post(
        "https://ekhoni-khabo-server.vercel.app/api/v1/customer/send-message",
        requestData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      console.log("Order submitted successfully:", response.data);

      // 🔥 FIRE PURCHASE EVENT IMMEDIATELY AFTER SUCCESSFUL ORDER
      if (window.fbq && response.status === 200) {
        // Get item IDs and names for tracking
        const contentIds = cart.map((item) => item._id);
        const contentNames = cart.map((item) => item.title);
        const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);

        window.fbq("track", "Purchase", {
          value: grandTotal, // Grand total including delivery
          currency: "BDT", // Your currency
          content_ids: contentIds, // Array of item IDs
          content_names: contentNames, // Array of item names
          content_type: "product",
          num_items: totalItems,
          // Optional: Add customer info for better tracking
          customer_name: form.name,
          customer_phone: form.phoneNumber,
          // Optional: Add order reference
          order_id: response.data.orderId || `order_${Date.now()}`,
        });

        console.log("🔥 Purchase event fired!", {
          value: grandTotal,
          items: totalItems,
          orderId: response.data.orderId || `order_${Date.now()}`,
        });
      }

      setForm({
        name: "",
        address: "",
        phoneNumber: "",
        email: "",
        instructions: "",
      });

      if (response.status === 200) {
        setCart([]);
        localStorage.removeItem("cart");
        localStorage.removeItem("cartTimestamp");
        navigate("/", {
          state: {
            success: "Order placed successfully! We will call you to confirm!",
          },
        });
      } else {
        toast("Failed to place order. Please try again.");
      }
    } catch (err) {
      console.error("Error submitting order:", err);
      setError("Failed to place order. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (cart.length === 0) {
    return (
      <section className="order-form-empty">
        <div className="order-form-container">
          <h3 className="order-form-heading">Your cart is empty</h3>
          <p className="order-form-description">
            Please add items to your cart before placing an order.
          </p>
        </div>
      </section>
    );
  }

  return (
    <section className="order-form" id="order-form">
      <div className="order-form-container">
        <h3 className="order-form-heading">Order Delivery Details</h3>
        <p className="order-form-description">
          Please fill up this form to confirm your order and delivery
        </p>
        <p className="text-xl font-bold text-center pb-3">
          Once you have placed your order, our customer service will call you
          and confirm your order
        </p>
        <p className="text-xl font-bold text-center pb-3">
          {
            "(আপনি আপনার অর্ডার দেওয়ার পরে, আমাদের গ্রাহক পরিষেবা আপনাকে কল করবে এবং আপনার অর্ডার নিশ্চিত করবে)"
          }
        </p>
        {error && <p className="error-message">{error}</p>}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
        <form className="form" onSubmit={handleSubmit}>
          <div className="form-group name-group">
            <label htmlFor="name" className="form-label">
              Name*
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="Your name"
              className="form-input"
              required
            />
          </div>

          <div className="form-group address-group">
            <label htmlFor="address" className="form-label">
              Address*
            </label>
            <input
              type="text"
              id="address"
              name="address"
              value={form.address}
              onChange={handleChange}
              placeholder="Your address"
              className="form-input"
              required
            />
          </div>

          <div className="form-group phone-number-group">
            <label htmlFor="phoneNumber" className="form-label">
              Phone Number*
            </label>
            <input
              type="text"
              id="phoneNumber"
              name="phoneNumber"
              value={form.phoneNumber}
              onChange={handleChange}
              placeholder="Your phone no"
              className="form-input"
              required
            />
          </div>

          <div className="form-group email-group">
            <label htmlFor="email" className="form-label">
              Email
            </label>
            <input
              type="string"
              id="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Your email"
              className="form-input"
            />
          </div>

          <div className="form-group instructions-group">
            <label htmlFor="instructions" className="form-label">
              Requests / Message
            </label>
            <textarea
              id="instructions"
              name="instructions"
              value={form.instructions}
              onChange={handleChange}
              placeholder="Any special request / message you might have on the order or the delivery"
              className="form-textarea"
            ></textarea>
          </div>

          <button type="submit" className="form-btn btn btn-primary">
            {loading ? "Submitting..." : "Order"}
          </button>
        </form>
      </div>
    </section>
  );
};

export default OrderForm;
